<template>
<div class="snapshots-averages">
    <div class="snapshots-averages-period">{{ title }}</div>
    <div class="columns">
        <div class="column is-half" style="padding-right: 20px;">
            <font-awesome-icon icon="hdd"/>
            <span class="custom-tag-avg tooltip" :class="{ 'is-tooltip-multiline': averageSnapshotSizeEvolution !== null }" :data-tooltip="averageSnapshotSizeEvolutionTooltip">{{ averageSnapshotSizeEvolutionText }}</span>
            <div class="averages-title">Average size</div>
            <div class="averages-value">{{ averageSnapshotSizeText }}</div>
        </div>
        <div class="column is-half">
            <font-awesome-icon icon="clock"/>
            <span class="custom-tag-avg tooltip" :class="{ 'is-tooltip-multiline': averageSnapshotDurationEvolution !== null }" :data-tooltip="averageSnapshotDurationEvolutionTooltip">{{ averageSnapshotDurationEvolutionText }}</span>
            <div class="averages-title">Average duration</div>
            <div class="averages-value">{{ averageSnapshotDurationText }}</div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';

export default {
    props: ['days'],

    data() {
        return {
            averageSnapshotSize: null,
            averageSnapshotSizeEvolution: null,
            averageSnapshotDuration: null,
            averageSnapshotDurationEvolution: null,
        }
    },

    mounted() {
        this.getStats();
    },

    methods: {
        getStats() {
            Api().get('users/current/stats/snapshots-and-backups-average-stats?days=' + this.days)
                .then((response) => {
                    this.averageSnapshotSize = response.data.average_snapshot_size;
                    this.averageSnapshotSizeEvolution = response.data.average_snapshot_size_evolution;
                    this.averageSnapshotDuration = response.data.average_snapshot_duration;
                    this.averageSnapshotDurationEvolution = response.data.average_snapshot_duration_evolution;
                })
                .catch((error) => {
                    //
                });
        },
    },

    computed: {
        title() {
            return 'Last ' + this.days + ' days';
        },

        averageSnapshotSizeText() {
            if (this.averageSnapshotSize === null) {
                return '-';
            }

            return this.averageSnapshotSize + ' GB';
        },

        averageSnapshotSizeEvolutionText() {
            if (this.averageSnapshotSizeEvolution === null) {
                return 'N/A';
            }

            if (this.averageSnapshotSizeEvolution.charAt(0) == '-') {
                return this.averageSnapshotSizeEvolution + '%';
            }

            return '+' + this.averageSnapshotSizeEvolution + '%';
        },

        averageSnapshotDurationText() {
            if (this.averageSnapshotDuration === null) {
                return '-';
            }

            return this.averageSnapshotDuration + ' min';
        },

        averageSnapshotDurationEvolutionText() {
            if (this.averageSnapshotDurationEvolution === null) {
                return 'N/A';
            }

            if (this.averageSnapshotDurationEvolution.charAt(0) == '-') {
                return this.averageSnapshotDurationEvolution + '%';
            }

            return '+' + this.averageSnapshotDurationEvolution + '%';
        },

        averageSnapshotDurationEvolutionTooltip() {
            if (this.averageSnapshotDurationEvolutionText == 'N/A') {
                return 'Average snapshot & backup duration evolution not available.';
            }

            var direction = 'up';

            if (this.averageSnapshotDurationEvolutionText.charAt(0) == '-') {
                direction = 'down';
            }

            var delta = this.averageSnapshotDurationEvolutionText.substr(1);

            return 'In the last ' + this.days + ' days, the average time required to complete a snapshot & backup is ' + direction + ' by ' + delta + ' compared to the previous ' + this.days + ' days.';
        },

        averageSnapshotSizeEvolutionTooltip() {
            if (this.averageSnapshotSizeEvolutionText == 'N/A') {
                return 'Average snapshot & backup size evolution not available.';
            }

            var direction = 'up';

            if (this.averageSnapshotSizeEvolutionText.charAt(0) == '-') {
                direction = 'down';
            }

            var delta = this.averageSnapshotSizeEvolutionText.substr(1);

            return 'In the last ' + this.days + ' days, the average size of a snapshot & backup is ' + direction + ' by ' + delta + ' compared to the previous ' + this.days + ' days.';
        },
    },
}
</script>
